export class ObjectStoreCoverageReasonEntry {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "reason",
            "baseName": "reason",
            "type": "ObjectStoreCoverageReason",
            "format": ""
        },
        {
            "name": "objects",
            "baseName": "objects",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "bytes",
            "baseName": "bytes",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return ObjectStoreCoverageReasonEntry.attributeTypeMap;
    }
    constructor() {
    }
}
